<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

export default {
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    Card
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    culturasProdutividade: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      forms: {
        cultura: '',
        produtividade: ''
      }
    }
  },
  computed: {
    disableButton () {
      return !(this.forms.cultura && this.forms.produtividade)
    }
  },
  methods: {
    btnAdicionar () {
      this.culturasProdutividade.push({
        ...this.forms
      })
      this.forms = {
        cultura: '',
        produtividade: ''
      }
    },
    btnApagar (index) {
      this.culturasProdutividade.splice(index, 1)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow
      title="Cultura e produtividade"
    />
    <el-row :gutter="20">
      <validation-provider
        :rules="!culturasProdutividade.length ? 'required' : ''"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Cultura`"
      >
        <el-col :span="6">
          <Label label="Cultura" :obrigatorio="!culturasProdutividade.length" />
          <el-input
            name="Cultura"
            v-model="forms.cultura"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider
        :rules="!culturasProdutividade.length ? 'required' : ''"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Produtividade (em kg)`"
      >
        <el-col :span="6">
          <Label label="Produtividade (em kg)" :obrigatorio="!culturasProdutividade.length" />
          <el-input
            name="Produtividade (em kg)"
            v-model="forms.produtividade"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <el-col :span="4" class="ml-3">
        <div class="mb-1">&nbsp;</div>
        <el-button
          :disabled="disableButton"
          round type="primary"
          @click="btnAdicionar()"
        >
          Adicionar
        </el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20" v-if="culturasProdutividade.length">
      <div class="flex-wrapper row">
        <div v-for="(e, i) in culturasProdutividade" :key="i+e.cultura">
          <Card
            :objeto="{
              ...e,
              produtividade: e.produtividade + ' kg'
              }"
            :deletar="() => btnApagar(i)"
            titulo="Cultura e produtividade"
          />
        </div>
      </div>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/CulturaProdutividade/CulturaProdutividade.vue